function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "settings");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("g", {
  id: "settings"
}, /*#__PURE__*/React.createElement("path", {
  d: "M34.87,59h-12a2.5,2.5,0,0,1-2.5-2.5V51.2a4,4,0,0,0-6.06-3.5L9.74,50.35a2.5,2.5,0,0,1-3.41-.91l-6-10.38a2.41,2.41,0,0,1-.25-1.89,2.5,2.5,0,0,1,1.16-1.52L5.84,33a4,4,0,0,0,0-7L1.25,23.35A2.5,2.5,0,0,1,.09,21.83a2.41,2.41,0,0,1,.25-1.89l6-10.38a2.5,2.5,0,0,1,3.41-.91l4.59,2.65a4,4,0,0,0,6.06-3.5V2.5A2.5,2.5,0,0,1,22.89,0h12a2.5,2.5,0,0,1,2.5,2.5V7.8a4,4,0,0,0,2,3.5,4.1,4.1,0,0,0,4,0L48,8.65a2.5,2.5,0,0,1,3.41.91l6,10.38a2.5,2.5,0,0,1-.91,3.41L51.92,26a4,4,0,0,0,0,7l4.59,2.65a2.5,2.5,0,0,1,.91,3.41l-6,10.38a2.5,2.5,0,0,1-3.41.91L43.43,47.7a4.1,4.1,0,0,0-4,0,4,4,0,0,0-2,3.5v5.3A2.5,2.5,0,0,1,34.87,59Zm-9.48-5h7V51.2a9,9,0,0,1,13.56-7.83l2.42,1.4,3.49-6-2.42-1.4a9,9,0,0,1,0-15.66l2.42-1.4-3.49-6-2.42,1.4A9,9,0,0,1,32.37,7.8V5h-7V7.8a9,9,0,0,1-13.56,7.83l-2.42-1.4-3.49,6,2.42,1.4a9,9,0,0,1,0,15.66l-2.42,1.4,3.49,6,2.42-1.4A9,9,0,0,1,25.39,51.2Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.88,39a9.5,9.5,0,1,1,9.5-9.5A9.51,9.51,0,0,1,28.88,39Zm0-14a4.5,4.5,0,1,0,4.5,4.5A4.51,4.51,0,0,0,28.88,25Z"
}))));

var SvgSettings = function SvgSettings(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57.76 59",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSettings, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/settings.7d772460.svg";
export { ForwardRef as ReactComponent };